<!-- !['', null, undefined].includes(listVoteAll) -->
<div class="lg:p-4 w-full relative">
    <div class="!sticky bg-white flex items-center justify-start lg:p-0 p-4 top-0 w-full z-20">
        <i class="ico-Close cursor-pointer text-xl ml-3" (click)="closeModal()"></i>
        <h2 class="text-lg">نظرات میهمانان  {{modalData.HotelHeader.FullName}} </h2>
    </div>
    <div class="w-full flex flex-wrap lg:border-bottom p-4 lg:p-0">
        <div class="flex items-center mt-3 lg:w-[30%] w-full mb-3 ">
            <div class="w-[40%] flex items-end">
                <h3 class="text-[40px] text-blue-500 font-bold">{{modalData.dataSource.AvgRate}}</h3>
                <span class="text-sm text-muted mb-1">/</span>
                <span class="text-sm text-muted mb-1">5</span>
                <div class="mr-3">
                    <p class="text-sm"> {{modalData.dataSource.AvgRateTitle}}</p>
                    <p class="text-sm text-muted">{{modalData.dataSource.TotalReview}} نظر</p>
                </div>
            </div>

            <div class="w-[50%]">
                <iho-progressbar [title]="accommodation() != 'ecolodge' ? 'امکانات هتل' : 'امکانات اقامتگاه'"
                 [score]="modalData?.dataSource.FacilitiesReview" 
                    [hasAnimation]="true" [progressValue]="modalData?.dataSource.FacilitiesReview" [min]="0"
                    [max]="5" />
                <iho-progressbar [title]="' موقعیت مکانی'" [score]="modalData?.dataSource.LocationReview"
                    [hasAnimation]="true" [progressValue]="modalData?.dataSource.LocationReview" [min]="0" [max]="5" />
                <iho-progressbar 
                    [title]="accommodation() != 'ecolodge' ? ' پاکیزگی هتل و اتاق ها' : ' پاکیزگی اقامتگاه  و اتاق ها'"
                    [score]="modalData?.dataSource.CleanlinessReview" 
                    [hasAnimation]="true" [progressValue]="modalData?.dataSource.CleanlinessReview" [min]="0"
                    [max]="5" />
            </div>
        </div>
        <div class="lg:w-[70%] flex justify-start items-center  w-full lg:overflow-visible overflow-x-scroll x-scroll">
            <div
                class="border border-solid p-3 flex-grow-0 flex-shrink-0  rounded-lg ml-3  flex flex-col justify-center items-center">
                <p class="text-xs text-gray-500">موقعیت و دسترسی</p>
                <p class="text-base font-bold"> {{modalData?.dataSource.LocationReview}} <span class="text-black-300"> /
                        5</span> </p>
            </div>
            <div
                class="border border-solid p-3 flex-grow-0 flex-shrink-0  rounded-lg ml-3   flex flex-col justify-center items-center">
                <p class="text-xs text-gray-500" *ngIf="accommodation() != 'ecolodge'">ارزش هتل نسبت به قیمت</p>
                <p class="text-xs text-gray-500" *ngIf="accommodation() == 'ecolodge'">ارزش اقامتگاه نسبت به قیمت</p> 
                <p class="text-base font-bold"> {{modalData?.dataSource.ValueForMoneyReview}} <span
                        class="text-black-300"> /
                        5</span></p>
            </div>
            <div
                class="border border-solid p-3 flex-grow-0 flex-shrink-0  rounded-lg ml-3   flex flex-col justify-center items-center">
                <p class="text-xs text-gray-500">آرامش و راحتی</p>
                <p class="text-base font-bold">{{modalData?.dataSource.ComfortReview}} <span class="text-black-300"> /
                        5</span></p>
            </div>
            <div
                class="border border-solid p-3 flex-grow-0 flex-shrink-0  rounded-lg ml-3   flex flex-col justify-center items-center">
                <p class="text-xs text-gray-500">عملکرد کارکنان</p>
                <p class="text-base font-bold">{{modalData?.dataSource.StaffReview}} <span class="text-black-300"> /
                        5</span></p>
            </div>
            <div
                class="border border-solid p-3 flex-grow-0 flex-shrink-0  rounded-lg ml-3   flex flex-col justify-center items-center">
                <p class="text-xs text-gray-500" *ngIf="accommodation() != 'ecolodge'"> پاکیزگی هتل و اتاق ها</p>
                <p class="text-xs text-gray-500" *ngIf="accommodation() == 'ecolodge'"> پاکیزگی اقامتگاه و اتاق ها</p>
                <p class="text-base font-bold">{{modalData?.dataSource.CleanlinessReview}} <span class="text-black-300">
                        / 5</span></p>
            </div>
            <div 
                class="border border-solid p-3 flex-grow-0 flex-shrink-0  rounded-lg ml-3   flex flex-col justify-center items-center">
                <p class="text-xs text-gray-500">امکانات</p>
                <p class="text-base font-bold"> {{modalData?.dataSource.FacilitiesReview}} <span class="text-black-300">
                        /
                        5</span></p>
            </div>
            <div *ngIf="modalData?.dataSource.FoodReview != 0"
                class="border border-solid p-3 flex-grow-0 flex-shrink-0  rounded-lg ml-3   flex flex-col justify-center items-center">
                <p class="text-xs text-gray-500">کیفیت غذا</p>
                <p class="text-base font-bold"> {{modalData?.dataSource.FoodReview}} <span class="text-black-300"> /
                        5</span></p>
            </div>
        </div>
    </div>
    <div class="py-2 !sticky z-20 w-full top-[50px] flex mt-3 bg-gray-200 lg:hidden overflow-x-auto x-scroll">
        <button (click)="showFiltersSec()"
            class="border border-solid mr-2 bg-white border-metal-200 px-4 py-1 rounded-full flex justify-center items-center  ml-2">
            <i class="ico-Filter text-xl mx-1 font-bold"></i>
            <span class="font-bold text-sm">فیلترها</span>
        </button>
        <button (click)="showFiltersScore()"
            class="border border-solid bg-white border-metal-200 px-4 py-1 rounded-full flex justify-center items-center ml-2">
            <i class="ico-Sort text-2xl mx-1 font-bold"></i>
            <span class="font-bold text-sm whitespace-nowrap"> امتیاز میهمانان</span>
        </button>
        <button (click)="showFiltersDate()"
            class="border border-solid bg-white border-metal-200 px-4 py-1 rounded-full flex justify-center items-center ml-2">
            <i class="ico-Sort text-2xl mx-1 font-bold"></i>
            <span class="font-bold text-sm whitespace-nowrap"> تاريخ نظرات </span>
        </button>


    </div>
    <div class="w-full lg:flex lg:mt-3 lg:p-3">
        <div *ngIf="accommodation() != 'ecolodge'" class="lg:w-[30%] w-full  overflow-y-auto lg:h-[58vh] lg:min-h-[540px] p-3 hidden lg:block">
            <div class="w-full flex justify-between mb-3 h-[36px]">
                <h2 class="text-base font-bold">فیلتر نظرات</h2>
                <button *ngIf="showRemoveBtn" (click)="removeFilters()" class="!border antialiased
                !border-solid
                !border-blue-500" mat-button color="primary">
                    حذف فیلترها
                </button>
            </div>
            <div class="w-full flex justify-between flex-wrap lg:flex-nowrap">
                <mat-form-field class="lg:ml-2 w-full lg:w-auto mb-3 lg:mb-0">
                    <mat-label class="!text-sm">نوع سفر </mat-label>
                    <mat-select [(ngModel)]="selectedType" (ngModelChange)="selectedTypes($event)">

                        <mat-option class="!text-sm" *ngFor="let item of listRoomsFilters?.travelTypes"
                            [value]="item.id">
                            {{item.name}}
                        </mat-option>

                    </mat-select>
                </mat-form-field>
                <mat-form-field class="w-full lg:w-auto" *ngIf="accommodation() != 'ecolodge'">
                    <mat-label class="!text-sm">نوع اتاق</mat-label>
                    <mat-select [(ngModel)]="selectedRoom" (ngModelChange)="selectedTypes($event)">
                        <mat-option class="!text-sm" selected [value]="0">
                            همه
                        </mat-option>
                        <mat-option class="!text-sm" *ngFor="let item of listRoomsFilters?.rooms" [value]="item.id">
                            {{item.name}}
                        </mat-option>

                    </mat-select>
                </mat-form-field>
            </div>

            <ul class="flex flex-wrap mt-3">
                <li class="border border-solid rounded-3xl p-2 mb-2 ml-2 cursor-pointer {{item.selected ? 'bg-blue-500 text-white' : 'text-gray-600'}}"
                    (click)="selectedLabels(item.name,'desk')"
                    *ngFor="let item of listRoomsFilters?.voteFilterLabels;let index = index">
                    <span class="text-sm"> {{item.name}} ({{item.count}})</span>
                </li>
            </ul>

            <div class="lg:block hidden">
                <h4 class="mb-3">امتیاز میهمانان</h4>
                <ul class="flex flex-wrap ">
                    <li class="border border-solid rounded-3xl p-2 mb-2 ml-2 cursor-pointer {{item.selected ? 'bg-blue-500 text-white' : 'text-gray-600'}}"
                        (click)="selectedScore(item.id,'desk')" *ngFor="let item of guestScore;let index = index">
                        <span class="text-sm  "> {{item.title}} </span>
                    </li>
                </ul>
            </div>
            <div class="lg:block hidden">
                <h4 class="my-3"> تاریخ نظرات</h4>
                <ul class="flex flex-wrap ">
                    <li class="border border-solid rounded-3xl p-2 mb-2 ml-2 cursor-pointer {{item.selected ? 'bg-blue-500 text-white' : 'text-gray-600'}}"
                        (click)="selectedHistoryComments(item.id,'desk')"
                        *ngFor="let item of historyComments;let index = index">
                        <span class="text-sm"> {{item.title}}</span>
                    </li>
                </ul>
            </div>


        </div>
        <!-- comment container -->
    
        <div #containerComments (scroll)="onScroll($event)"
        [ngClass]="accommodation() != 'ecolodge' ? 'lg:w-[70%]' : 'lg:w-full'"
            class=" bg-gray-200 p-3 lg:rounded-lg overflow-y-auto lg:h-[58vh] h-[55vh] lg:min-h-[540px] relative">

            <div class="w-full h-full flex justify-center items-center" *ngIf="loadingData">

                <iho-loading></iho-loading>

            </div>

            <ng-container *ngIf="!loadingData">
                <div class="w-full flex flex-col justify-center items-center h-[55vh]" *ngIf="showEmpty">
                    <img [src]="cdnUrl + '/images/empty-view.png'" class="mb-3 mx-auto" height="140" width="170"
                        alt="واحد اقامتی پیدا نشد">
                    <p class="text-black-400 text-sm text-center">
                        متاسفانه هیچ نظری پیدا نشد!
                    </p>
                </div>

                <div class="w-full p-3 px-3 pt-0 border-bottom bg-white rounded-lg mb-3"
                    *ngFor="let item of listVoteAll">
                    <div class="w-full p-3">
                        <div class="w-full mt-4">

                            <p class="text-sm">
                                <span class="text-sm text-blue-500 font-bold">{{item.rate.replace('.0','')}}</span>
                                <span class="text-sm mr-2 text-black-500 font-bold">{{item.rateTitle}}</span>
                            </p>
                            <p class="text-sm text-black-300"> {{item.guestName}}</p>
                            <p class="text-xs text-gray-500" *ngIf="accommodation() != 'ecolodge'">تاریخ درج نظر : {{item.addDatePersian}}</p>

                        </div>
                        <div class="w-full mt-4">
                            <h4 class="text-sm font-bold">{{item.title}}</h4>
                            <p class="text-sm text-black-300 mt-3">
                                {{item.description}}
                            </p>
                            <p class="text-sm text-black-200 mt-3" *ngIf="accommodation() != 'ecolodge'">
                                <span>تاریخ ورود:</span>
                                <span class="mr-2">
                                    {{item.arrivalDatePersian}}
                                </span>
                                <span class="mx-2">|</span>
                                <span class="">{{item.duration}} شب اقامت</span>
                            </p>
                        </div>
                        <div class="w-full mt-4 text-sm text-black-200" *ngIf="accommodation() == 'ecolodge'">
                            <span>{{item.addDatePersian}}</span>
                        </div>
                        <!-- HotelAnswer -->
                        <div class="w-full mt-4 bg-metal-50 p-3 rounded-lg" *ngIf="item.hotelAnswer">
                            <h4 class="text-sm font-bold" *ngIf="accommodation() == 'ecolodge';else nameCommentHost">”پاسخ میزبان"</h4>
                            <ng-template #nameCommentHost>
                                <h4 class="text-sm font-bold">”پاسخ هتل“</h4> 
                            </ng-template>
                            <p class="text-sm text-black-300 mt-3">
                                {{item?.hotelAnswer}}
                            </p>
                            <p class="text-sm text-black-200 mt-3">
                                {{item?.answerDatePersian}}
                            </p>
                        </div>
                    </div>

                </div>
                <ng-container *ngIf="loadingScroll && listVoteAll.length">
                    <div class=" w-full p-5 " id="loadingScroll">
                        <div class="typing-animation !w-full h-full flex justify-center items-center">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </div>

</div>
<ng-template #showFiltersScoreTemplate>
    <div class="w-full p-3">
        <div class="w-full flex items-center justify-between">
            <div class="w-full flex items-center">
                <i class="ico-Close text-2xl mx-2 p-2" (click)="closeBottomSheet()"></i>
                <h4 class="">امتیاز میهمانان</h4>
            </div>
            <button *ngIf="showRemoveBtn" (click)="removeFilters()" class="!border antialiased float-left
       !border-solid w-[130px]
       !border-blue-500" mat-button color="primary">
                حذف فیلترها
            </button>
        </div>

        <ul class="flex flex-wrap ">
            <li class="border border-solid rounded-3xl p-2 mb-2 ml-2 {{item.selected ? 'bg-blue-500 text-white' : 'text-gray-600'}}"
                (click)="selectedScore(item.id,'mobile')" *ngFor="let item of guestScore;let index = index">
                <span class="text-sm"> {{item.title}} </span>
            </li>
        </ul>
        <div class="w-full  bg-white ">
            <button class="w-full !h-11" (click)="getVotesAll('mobile',10,1)" mat-raised-button color="primary">
                اعمال فیلتر
            </button>
        </div>
    </div>

</ng-template>
<ng-template #showFiltersDateTemplate>

    <div class="w-full p-3">
        <div class="w-full flex items-center justify-between">
            <div class="w-full flex items-center">
                <i class="ico-Close text-2xl mx-2 p-2" (click)="closeBottomSheet()"></i>
                <h4 class=""> تاریخ نظرات</h4>
                <button *ngIf="showRemoveBtn" (click)="removeFilters()" class="!border antialiased float-left
           !border-solid w-[130px]
           !border-blue-500" mat-button color="primary">
                    حذف فیلترها
                </button>
            </div>
        </div>

        <ul class="flex flex-wrap ">
            <li class="border border-solid rounded-3xl p-2 mb-2 ml-2 {{item.selected ? 'bg-blue-500 text-white' : 'text-gray-600'}}"
                (click)="selectedHistoryComments(item.id,'mobile')"
                *ngFor="let item of historyComments;let index = index">
                <span class="text-sm"> {{item.title}}</span>
            </li>
        </ul>
        <div class="w-full  bg-white ">
            <button class="w-full !h-11" (click)="getVotesAll('mobile',10,1)" mat-raised-button color="primary">
                اعمال فیلتر
            </button>
        </div>
    </div>
</ng-template>


<ng-template #showFiltersCommentsTemplate>
    <div class="">
        <div class="w-full flex items-center justify-between">
            <div class=" flex items-center">
                <i class="ico-Close text-2xl mx-2 p-2" (click)="closeBottomSheet()"></i>
                <h3>فیلتر نظرات</h3>
            </div>
            <button *ngIf="showRemoveBtn" (click)="removeFilters()" class="!border antialiased float-left w-[130px]
           !border-solid
           !border-blue-500" mat-button color="primary">
                حذف فیلترها
            </button>
        </div>
        <div class="w-full flex justify-between flex-wrap lg:flex-nowrap">
            <mat-form-field class="lg:ml-2 w-full lg:w-auto mb-3 lg:mb-0">
                <mat-label class="!text-sm">نوع سفر </mat-label>
                <mat-select [(ngModel)]="selectedType" (ngModelChange)="showRemoveBtn=true">

                    <mat-option class="!text-sm" *ngFor="let item of listRoomsFilters?.travelTypes" [value]="item.id">
                        {{item.name}}
                    </mat-option>

                </mat-select>
            </mat-form-field>
            <mat-form-field class="w-full lg:w-auto">
                <mat-label class="!text-sm">نوع اتاق</mat-label>
                <mat-select [(ngModel)]="selectedRoom" (ngModelChange)="showRemoveBtn=true">
                    <mat-option class="!text-sm" selected [value]="0">
                        همه
                    </mat-option>
                    <mat-option class="!text-sm" *ngFor="let item of listRoomsFilters?.rooms" [value]="item.id">
                        {{item.name}}
                    </mat-option>

                </mat-select>
            </mat-form-field>
        </div>

        <ul class="flex flex-wrap mt-3">
            <li class="border border-solid rounded-3xl p-2 mb-2 ml-2 {{item.selected ? 'bg-blue-500 text-white' : 'text-gray-600'}}"
                (click)="selectedLabels(item.name,'mobile')"
                *ngFor="let item of listRoomsFilters?.voteFilterLabels;let index = index">
                <span class="text-sm"> {{item.name}} ({{item.count}})</span>
            </li>
        </ul>
        <div class="w-full  bg-white ">
            <button class="w-full !h-11" (click)="getVotesAll('mobile',10,1)" mat-raised-button color="primary">
                اعمال فیلتر
            </button>
        </div>
    </div>
</ng-template>

<ng-template #loading>
    <div class="w-full h-full flex justify-center items-center">
        <iho-loading></iho-loading>

    </div>

</ng-template>